import { DELETE_ABOUT_US_START } from '../../types';

export const delete_about_us = (payload) => ({
  type: DELETE_ABOUT_US_START,
  payload,
});
